var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDollar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.542,
    height: 24.236,
    viewBox: "0 0 14.542 24.236",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "dollar-svgrepo-com",
    d: "M18.117,9.877h2.424c0-3.438-3.338-5.006-6.059-5.367V2H12.058V4.51C9.337,4.871,6,6.439,6,9.877c0,3.279,3.231,4.984,6.059,5.368v6.023c-1.755-.3-3.635-1.241-3.635-2.908H6c0,3.137,2.939,4.991,6.059,5.376v2.5h2.424V23.727c2.72-.361,6.059-1.93,6.059-5.368s-3.338-5.006-6.059-5.367V6.968c1.612.29,3.635,1.14,3.635,2.908Zm-9.694,0c0-1.768,2.024-2.619,3.635-2.908v5.815C10.4,12.477,8.423,11.57,8.423,9.877Zm9.694,8.483c0,1.768-2.024,2.619-3.635,2.908V15.451C16.093,15.741,18.117,16.591,18.117,18.359Z",
    transform: "translate(-5.999 -2)",
    fill: "#ea1e63"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar);
export default __webpack_public_path__ + "static/media/dollar.0c9e5f36868bf9a260e43b4290e47da7.svg";
export { ForwardRef as ReactComponent };